<template>
  <div>
    <Endereco :listaDeErros="dadosRetorno.listaDeErros" v-model="formulario" :flagsDeControle="flagsDeControle" :consultaUnidadesFederativas="obterUnidadesFederativas"/>
  </div>
</template>

<script>
import AbaEndereco from './js/aba-endereco'
export default AbaEndereco
</script>
